module.exports = __webpack_public_path__ + "static/media/web-page-home.cdf32056.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/web-page-home.svg
// module id = 1483
// module chunks = 0